(function () {
  angular.module('MktzapApp.Factories')
    .factory('KnowledgeBaseTagService', KnowledgeBaseTagService);

  KnowledgeBaseTagService.$inject = ['$resource'];

  function KnowledgeBaseTagService ($resource) {
    return $resource(apiUrl + '/knowledge-base-tag/:id', { id: '@id' }, {
      all: { url: apiUrl + '/knowledge-base-tag/all', method: 'GET', params: {}, isArray: true },
      searchTag: { url: apiUrl + '/knowledge-base-tag/search-tag', method: 'POST', params: {}, isArray: true },
      create: { url: apiUrl + '/knowledge-base-tag/create', method: 'POST', params: {}, isArray: false },
      delete: { url: apiUrl + '/knowledge-base-tag/delete', method: 'DELETE', params: {}, isArray: false }
    });
  }
})();
